import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchJson, postJson } from '../lib/api';

export interface Note {
  id: string;
  content: string;
  entityType: string;
  entityId: string;
  authorId?: string;
  authorName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NotesResponse {
  notes: Note[];
  total: number;
}

export function useNotes(entityType: string, entityId: string | null) {
  return useQuery({
    queryKey: ['notes', entityType, entityId],
    queryFn: () =>
      fetchJson<NotesResponse>(`/api/notes?entityType=${entityType}&entityId=${entityId}`),
    enabled: !!entityId,
  });
}

export function useCreateNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { content: string; entityType: string; entityId: string }) =>
      postJson<Note>('/api/notes', data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['notes', variables.entityType, variables.entityId],
      });
    },
  });
}
